export const colors = {
  gold: '#d4af37',
  goldLight: '#f4d03f',
  bg: '#0a0a1a',
  bgCard: 'rgba(13, 20, 40, 0.85)',
  bgCardHover: 'rgba(13, 20, 40, 0.9)',
  border: 'rgba(212,175,55,0.12)',
  text: '#f0f0f0',
  textMuted: '#b0b0b0',
  error: '#dc3545',
  success: '#28a745',
};

export const spacing = {
  xs: '8px',
  sm: '12px',
  md: '16px',
  lg: '24px',
  xl: '32px',
};

export const radius = {
  sm: '8px',
  md: '10px',
  lg: '16px',
  xl: '24px',
};

export const fontSize = {
  sm: '13px',
  md: '14px',
  lg: '15px',
  xl: '16px',
  title: '20px',
  heading: '32px',
};
